import Button from 'components/_UI/Button'
import ImageUpload from 'components/_UI/ImageUpload'
import Loader from 'components/_UI/Loader'
import Text from 'components/_UI/Text'
import React, { useState } from 'react'
import { ArrowLeft } from 'react-feather'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import colors from 'theme/colors'
import partnerOnboarding from 'api/requests/partnerOnboarding'

export default function PartnerFormStepTwo({
    onNextClick = () => { },
    onBackClick = () => { },
    onFilesChange = () => { }
}) {

    const [documentFront, setDocumentFront] = useState(null);
    const [documentBack, setDocumentBack] = useState(null);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const canProceed = documentFront && documentBack;

    async function onNextStep() {
        if (!canProceed) {
            setError(true);
            setErrorMessage('Envie a frente e o verso do documento para continuar.');
            return;
        }

        setError(false);
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append('document_front_image', documentFront);
            formData.append('document_back_image', documentBack);

            await partnerOnboarding.validate(formData);

            onFilesChange({ front: documentFront, back: documentBack });
            onNextClick();
        } catch ({ response }) {
            setError(true);
            setErrorMessage(response?.data?.message || 'Ocorreu um erro ao validar os documentos. Tente novamente.');
        } finally {
            setLoading(false);
        }
    }

    function onStepBack() {
        onBackClick();
    }

    return (
        <FormContainer>

            <Text name={'highlight'} color={colors.nightDark} textAlign={'center'}>
                Estamos quase lá! Agora precisamos de algumas informações para validar seu cadastro.
            </Text>

            {/* Upload Frente */}
            <Column marginTop='10px'>
                <ImageUpload
                    product
                    icon='docFront'
                    onToggleFile={e => {
                        setDocumentFront(e?.[0] || null);
                        setError(false);
                    }}
                    onDeleteFile={e => {
                        setDocumentFront(null);
                        setError(false);
                    }}
                />

                <Text
                    color={colors.nightDark}
                    textAlign={'center'}
                    paddingBottom={'2px'}
                    marginTop={'10px'}
                    type={'bold'}
                >
                    Envie a frente do seu documento (RG ou CNH)
                </Text>

                <Text
                    color={colors.nightDark}
                    textAlign={'center'}
                    name={'small'}
                >
                    Certifique-se de que a foto esteja legível e sem cortes.
                </Text>
            </Column>

            {/* Upload Verso */}
            <Column marginTop='15px'>
                <ImageUpload
                    product
                    icon='docBack'
                    onToggleFile={e => {
                        setDocumentBack(e?.[0] || null);
                        setError(false);
                    }}
                    onDeleteFile={e => {
                        setDocumentBack(null);
                        setError(false);
                    }}
                />

                <Text
                    color={colors.nightDark}
                    textAlign={'center'}
                    paddingBottom={'2px'}
                    marginTop={'10px'}
                    type={'bold'}
                >
                    Envie o verso do seu documento (RG ou CNH)
                </Text>

                <Text
                    color={colors.nightDark}
                    textAlign={'center'}
                    name={'small'}
                >
                    Todas as informações precisam estar visíveis.
                </Text>
            </Column>

            {error && (
                <Text
                    color={colors.danger}
                    textAlign={'center'}
                    marginTop={'15px'}
                    type={'bold'}
                >
                    {errorMessage}
                </Text>
            )}

            {/* Botões */}
            <Column marginTop='20px'>
                {loading ? (
                    <Loader />
                ) : (
                    <Button
                        category={'squiredBorded'}
                        variant={canProceed ? 'featured' : 'disabled'}
                        onClick={onNextStep}
                    >
                        Avançar
                    </Button>
                )}

                <Button
                    category={'minimalDark'}
                    onClick={onStepBack}
                >
                    <ArrowLeft size={22} /> &nbsp;
                    Voltar
                </Button>
            </Column>

        </FormContainer>
    )
}

const FormContainer = styled(Column)`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
`
